<template lang="pug">
  .component-backoffice-category-list.reporting-types-list.row.column
    .row
      .column.small-12.large-6.category(v-for="(type, index) in types" :key="`RT{type.id}-${index}`")
        .inner-content.card.text-center
          .row.text-center
            .column.text-left
              h2 {{ type.name }}
            .column.text-right
              ModalReveal(:ref="'reveal-'+type.uid")
                i.fa.fa-pencil(slot="trigger")

                EditReportingType(:reportingType="type", @reportingTypeEdited="reportEdited(type)")
              pre RT{{type.id}}

          .row.text-center
            .column.text-left
              p {{type.description}}
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import ModalReveal from '../../components/structure/foundation/ModalReveal'
  import EditReportingType from './EditReportingType'

  export default {
    name: 'ReportingTypesList',
    components: {EditReportingType, ModalReveal},
    data: function () {
      return {
        types: [],
        activeIndex: null,

      }
    },
    created() {
      this.loadReportingTypes()
    },
    methods: {
      setSearch(index) {
        this.activeIndex = index
      },
      reportEdited(type) {
        this.$refs['reveal-' + type.uid][0].close()
        this.loadReportingTypes()
      },
      loadReportingTypes() {
        KeplerBackofficeSdk.reportings.list(null, null,).types((data) => {
          this.types = data
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .reporting-types-list
    .category
      cursor: default
</style>



// WEBPACK FOOTER //
// ReportingTypesList.vue?0d5c58fa